<template>
  <v-card>
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Events
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-flex xs2 class="mr-4">
        <v-card flat>
          <v-select v-bind:items="status_filter" v-model="currentStatus" label="Status" single-line bottom></v-select>
        </v-card>
      </v-flex>
      <v-flex xs2 class="mr-4">
        <v-card flat>
          <v-select v-bind:items="default_filter" v-model="dateRange" label="Date Range" single-line bottom></v-select>
        </v-card>
      </v-flex>
      <v-flex xs3 style="margin-left: auto">
        <v-card flat>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card>
      </v-flex>
    </v-card-title>
    <v-data-table :headers="headers" :items="allEvents" :search="search" :pagination.sync="pagination"
      :rows-per-page-items="[15, 25, 50, 100]" v-if="allEvents.length > 0">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.submitdate | actualDate }}</td>
        <td class="text-xs-left" style="padding-right: 10px !important;width: 164px;">
          <div class="avatar" style="height: 24px; width: 24px;">
            <img v-if="props.item.user.avatar" :src="props.item.user.avatar" alt="logo">
            <img v-if="!props.item.user.avatar" src="https://randomuser.me/api/portraits/men/88.jpg" alt="logo">
          </div>
          {{ props.item.user.firstname }} {{ props.item.user.lastname }}
        </td>
        <td class="text-xs-left">{{ props.item.user.company.companylegalname }}</td>
        <td class="text-xs-left">{{ props.item.title | sliceText }}</td>
        <td class="text-xs-left">{{ props.item.eventdate | actualDate }}</td>
        <td class="text-xs-left">{{ props.item.approvalStatus | status }}</td>
        <td class="text-xs-left">
          <v-layout row>
            <v-flex xs3 sm3>
              <v-tooltip top>
                <v-btn slot="activator" @click.prevent="changeStatus(1, props.item.id)" :disabled="props.item.approvalStatus === 1"
                  icon class="green--text">
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Approve</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs3 sm3>
              <v-tooltip top>
                <v-btn slot="activator" icon @click.prevent="changeStatus(2, props.item.id)" :disabled="props.item.approvalStatus === 2">
                  <v-icon color="red">clear</v-icon>
                </v-btn>
                <span>Reject</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs3 sm3>
              <v-btn icon class="blue--text" @click.prevent="selectItem(props.item);assignId(props.item.id, 'activeDialog')">
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs3 sm3>
              <v-btn icon medium @click.prevent="selectItem(props.item);assignId(props.item.id, 'emailDialog')"
                :disabled="!props.item.approvalStatus == 1 && props.item.approvalStatus !== 2">
                <v-icon medium>email</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs3 sm3>
              <v-btn icon @click.prevent="selectItem(props.item);assignId(props.item.id, 'dialog')" class="red--text">
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <v-dialog v-model="activeDialog" lazy absolute width="790px">
      <v-card>
        <v-layout row>
          <v-flex xs12 sm12>
            <v-card>
              <v-toolbar card color="white" prominent>
                <v-toolbar-title>Event Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon @click.native="activeDialog = false">
                  <v-icon color="red">clear</v-icon>
                </v-btn>
              </v-toolbar>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>title</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>person</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.user.firstname }} {{ selectedItem.user.lastname }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>event</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.eventdate }}</v-list-tile-title>
                    <v-list-tile-sub-title>Event date</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>watch_later</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.starteventtime }} {{ selectedItem.endeventtime }}</v-list-tile-title>
                    <v-list-tile-sub-title>Event time</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>location_on</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.location }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>event_note</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ selectedItem.description }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color='primary'>link</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <a :href="selectedItem.link">
                      <v-list-tile-title>{{ selectedItem.link }}</v-list-tile-title>
                    </a>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailDialog" absolute max-width="500px">
      <v-card>
        <v-card-title class="headline">Confim Email</v-card-title>
        <v-card-text>Are you sure you want to mail <b>{{ selectedItem.user.firstname }}</b>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog= false;emailUser(selectedItem.uid, selectedItem.approvalStatus)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" lazy absolute max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Really delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete <b>{{ selectedItem.user.firstname }}'s</b> event?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteRow()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import moment from 'moment'

export default {
  computed: {
    events () {
      return this.$store.getters.fetchEvents
    },
    loading () {
      return this.$store.getters.getLoading
    },
    error () {
      return this.$store.getters.getError
    },
    updateProcess () {
      return this.$store.getters.getProcess === 'Settings Saved'
    },
    process () {
      return this.$store.getters.getProcess
    },
    allEvents () {
      if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
        let dateAfter = moment().clone().subtract(this.dateRange, 'days').startOf('day')
        return this.events.filter((event) => {
          if (this.currentStatus) {
            return event.approvalStatus === this.currentStatus
          }
          if (this.dateRange !== 0) {
            return moment(event.submitdate).isAfter(dateAfter)
          }
        }).sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
      } else {
        return this.events.sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
      }
    }
  },
  data () {
    return {
      emailDialog: false,
      selectedItem: {
        user: {}
      },
      search: '',
      e1: '',
      activeDialog: false,
      pagination: {
        rowsPerPage: 15
      },
      dialog: false,
      currentStatus: '',
      currentEventId: '',
      currentDate: '',
      dateRange: 0,
      view_dialog: false,
      headers: [
        {
          text: 'Submit Date',
          align: 'left',
          sortable: false,
          value: 'eventdate'
        },
        {
          text: 'Submitter',
          value: 'user',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Event Title',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Event Date',
          align: 'left',
          sortable: false,
          value: 'posteddate'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ],
      status_filter: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'Approved',
          value: 1
        },
        {
          text: 'Pending',
          value: 0
        },
        {
          text: 'Rejected',
          value: 2
        }
      ],
      default_filter: [
        {
          text: 'All',
          value: 0
        },
        {
          text: 'Last 24hrs',
          value: 1
        },
        {
          text: 'Last 7 days',
          value: 7
        },
        {
          text: 'Last 30 days',
          value: 30
        }
      ],
      items: []
    }
  },
  mounted () {
    this.getEvents()
  },
  methods: {
    selectItem (item) {
      this.selectedItem = item
    },
    emailUser (uid, approvalStatus) {
      let date = this.selectedItem.submitdate
      if (approvalStatus === 1) {
        this.$store.dispatch('sendMail', {uid: uid, action: 'event_approved', date})
      } else if (approvalStatus === 2) {
        this.$store.dispatch('sendMail', {uid: uid, action: 'event_rejected', date})
      }
    },
    changeStatus (status, postId) {
      const payload = {
        type: 'events',
        status,
        postId
      }
      this.$store.dispatch('changeStatus', payload)
    },
    deleteRow (selectedEvent) {
      const payload = {
        type: 'events',
        postId: this.currentEventId
      }
      this.$store.dispatch('deletePost', payload)
      this.dialog = false
    },
    assignId (postId, type) {
      this.currentEventId = postId
      this[type] = true
    },
    async getEvents () {
      try {
        const DB = this.$firebase.database()
        const eventSnap = await DB.ref('events').once('value')
        let events = eventSnap.val()
        const eventKeys = Object.keys(events)
        const promises = eventKeys.map(key => {
          const event = events[key]
          return new Promise(async (resolve, reject) => {
            try {
              const userSnap = await DB.ref(`users/${event.uid}`).once('value')
              const user = userSnap.val()
              const companySnap = await DB.ref(`companies/${user.cid}`).once('value')
              const company = companySnap.val() || {}
              return resolve({
                ...event,
                user: {
                  ...user,
                  company
                },
                avatar: user.avatar,
                id: key,
                eventKey: key
              })
            } catch (error) {
              reject(error)
            }
          })
        })
        events = await Promise.all(promises)
        this.$store.dispatch('fetchAllEvents', events)
      } catch (error) {
        console.log('An error occurred while pulling the events', error)
      }
    }
  }
}
</script>

<style scoped>
  #right {
    float: right !important;
  }
</style>



// WEBPACK FOOTER //
// events.vue?1cec1679